module.exports = __webpack_public_path__ + "img/9788976827845.9e14fe76.jpg";